import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

/**
 * StudentMedicalAlert — un-missable red pills for serious medical info.
 *
 * One red pill per serious item (severe/anaphylactic allergy or chronic
 * condition). Each pill is self-describing — the red colour + warning icon
 * carry the urgency, the text carries the detail. Words, not emoji. Renders
 * nothing when there's nothing serious on file.
 *
 * `items` is the output of getSeriousMedicalItems(profile).
 */
const labelFor = (item) => {
  const name = (item.label || '').trim();
  if (item.kind === 'allergy') {
    return /allerg/i.test(name) ? name : `${name} allergy`;
  }
  return name;
};

const StudentMedicalAlert = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {items.map((item, i) => (
        <span
          key={`${item.kind}-${item.label}-${i}`}
          className="inline-flex items-center gap-1 rounded-full border border-error/30 bg-error/10 px-2.5 py-0.5 text-xs font-semibold text-error"
        >
          <ExclamationTriangleIcon className="w-3.5 h-3.5 shrink-0" />
          {labelFor(item)}
          {item.severity === 'anaphylactic' && (
            <span className="font-normal opacity-70">· anaphylaxis</span>
          )}
        </span>
      ))}
    </div>
  );
};

export default StudentMedicalAlert;
